import React from "react";
import PropTypes from "prop-types";

const Tooltip = ({ description }) => (
  <span className="tooltip-container d-flex align-items-start">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className="tooltip-trigger svg-icon">
      <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z" />
    </svg>
    <span className="tooltip-text">{description}</span>
  </span>
);


Tooltip.propTypes = {
  description: PropTypes.string.isRequired,
};

Tooltip.defaultProps = {
};


export default Tooltip;
